export type A2HSTriggerSource = "plan" | "recipe" | "day" | "week";

export const A2HS_EVENT_AFTER_FIRST_PLAN = "a2hs-after-first-plan";
export const A2HS_EVENT_AFTER_FIRST_RECIPE = "a2hs-after-first-recipe";
export const A2HS_EVENT_AFTER_TWO_RECIPES = "a2hs-after-two-recipes";
export const A2HS_EVENT_AFTER_FIRST_DAY = "a2hs-after-first-day";
export const A2HS_EVENT_AFTER_FIRST_WEEK = "a2hs-after-first-week";
